export default __webpack_public_path__ + "static/media/app.3bb3cc0b.svg";